import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { HeaderService } from '../../services/header.service';
import { Subject, takeUntil } from 'rxjs';
import { commonConstants } from '../experiment-constants';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
  standalone: true,
  imports: [RouterLink]
})
export class HeaderComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private headerService = inject(HeaderService);

  username: string | undefined;
  modifiedRoleName = commonConstants.emptyString;
  private readonly destroy$ = new Subject<void>();
  projectId: string | null = null;
  projectNumber: string | null = null;
  projectIdQueryParam: string | null = null;
  projectNumberQueryParam: string | null = null;
  experimentName: string | null = null;

  ngOnInit(): void {
    this.headerService
      .GetHeaderState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((headerState) => {
        this.username = headerState.username;
        this.modifiedRoleName = headerState.modifiedRoleName;
        this.projectId = headerState.projectId;
        this.projectNumber = headerState.projectNumber;
        this.projectIdQueryParam = headerState.projectIdQueryParam;
        this.projectNumberQueryParam = headerState.projectNumberQueryParam;
        this.experimentName = headerState.experimentName;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  Logout() {
    this.authService.Logout();
  }

  GetBackToSampleList() {
    this.headerService.GetBackToSampleList(this.projectIdQueryParam, this.projectNumberQueryParam);
  }

  GoBackToProjectDetails() {
    this.headerService.GoBackToProjectDetails(this.projectId);
  }
}
